let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("32YGB")).then(() => parcelRequire('jQy0H'));